import React, { useMemo } from 'react';
import { Box, Card, CardActionArea, Typography } from '@mui/material';
import GavelIcon from '@mui/icons-material/Gavel';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import CalculateIcon from '@mui/icons-material/Calculate';
import { API_BASE } from './config';
import usePageTitle from './shared/hooks/usePageTitle';

const PORTALS = [
  {
    key: 'judge',
    label: 'Judges',
    description: 'Score entries and submit award nominations',
    Icon: GavelIcon,
  },
  {
    key: 'admin',
    label: 'Admin',
    description: 'Manage the competition and users',
    Icon: AdminPanelSettingsIcon,
  },
  {
    key: 'tabulator',
    label: 'Tabulators',
    description: 'Tabulate scores and compile results',
    Icon: CalculateIcon,
  },
];

export default function LoginPage() {
  usePageTitle('OSSDF Login');
  const errorParam = useMemo(
    () => new URLSearchParams(window.location.search).get('error'),
    []
  );

  const handlePortalClick = (portalKey) => {
    window.location.href = `${API_BASE}/api/glogin?portal=${portalKey}`;
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        p: 4,
        bgcolor: 'background.default',
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h4" component="h1" fontWeight={700} gutterBottom>
          OSSDF Awards
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Select your portal to sign in with Google
        </Typography>
      </Box>

      {errorParam === 'unauthorized' && (
        <Typography
          color="error"
          variant="body2"
          sx={{ bgcolor: 'error.light', px: 2, py: 1, borderRadius: 1 }}
        >
          You are not authorized for that portal. Please select the correct one or contact an administrator.
        </Typography>
      )}
      {errorParam === 'server' && (
        <Typography color="error" variant="body2">
          A server error occurred. Please try again.
        </Typography>
      )}

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
          gap: 3,
          width: '100%',
          maxWidth: 560,
        }}
      >
        {PORTALS.map(({ key, label, description, Icon }) => (
          <Card key={key} elevation={2}>
            <CardActionArea
              onClick={() => handlePortalClick(key)}
              sx={{ p: 3, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}
            >
              <Icon color="primary" sx={{ fontSize: 36 }} />
              <Typography variant="h6" fontWeight={600}>
                {label}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {description}
              </Typography>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </Box>
  );
}
